const keyboardDatePickerModalDocEmployee = {
  label: 'Validade'
};

export default keyboardDatePickerModalDocEmployee;
